module.exports = __webpack_public_path__ + "static/neck-hanger-8a79393f25360672c790baeeaa9ff6d2.png";